import React, { FunctionComponent } from 'react';

import { QuoteCarousel as QuoteCarouselType } from '@gojob/cms';
import Flex from '@gojob/ui-bits/Flex';
import { graphql } from 'gatsby';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Buttons from '../../Buttons';
import QuoteScroller from '../../QuoteScroller';
import Title from '../../Section/QuoteCarousel/Title';

export const QuoteCarouselFragment = graphql`
  fragment QuoteCarouselFragment on SanityQuotes {
    title {
      title
      level
    }
    subtitle
    variant {
      variant
    }
    ctas {
      ...CtaFragment
    }
    quote_cards {
      text
      author_role
      author_name
      avatar {
        alt
        hotspot {
          x
          y
        }
        asset {
          localFile {
            childImageSharp {
              gatsbyImageData(width: 160)
            }
          }
        }
      }
    }
  }
`;

const QuoteCarousel: FunctionComponent<QuoteCarouselType> = (props) => {
  const { title, subtitle, quote_cards, ctas = [] } = props;
  const { spacing } = useTheme();

  return (
    <Flex
      css={{ boxSizing: 'border-box' }}
      width="100%"
      flexDirection="column"
      alignItems="center"
      padding={4}
    >
      <Title title={title} subtitle={subtitle} />

      <Flex margin={[0, -4]} maxWidth={`calc(100% + ${spacing(8)})`}>
        <QuoteScroller items={quote_cards} />
      </Flex>
      <Buttons ctas={ctas} />
    </Flex>
  );
};

export default QuoteCarousel;
